import {RankedConstants} from '../../../../shared/GameEnums.ts'
import {MatchmakingMatchTypes} from '@colonist/game-base-types'
import {ClientUserState} from '../ClientUserState.ts'
import {ViewPopupLogin} from '../ui_popup/ui_popup_membership_incentive/ViewPopupLogin.ts'
import {ViewPopupBecomeMemberGameplay} from '../ui_popup/ViewPopupBecomeMemberGameplay.ts'
import {AnalyticEventValue} from '../../../../shared/entity_datas/EntityDatas.ts'
import {UserSessionUtils} from '../UserSessionUtils.ts'
import {ErrorsMatchmaking} from '../../../../shared/errors/ErrorsMatchmaking.ts'
import {BaseError} from '../../../../shared/errors/BaseError.ts'
import {TranslationObject} from '@colonist/i18n'
import {ViewPopup} from '../ui_popup/ViewPopup.ts'
import {uiManagerEvents} from '../EntryShared.ts'
import {userHasAccessToRankedCitiesAndKnights} from '../../../../shared/matchmaking/MatchmakingUtils'
import {
    citiesAndKnightsMatchmakingMatchTypes,
    rankedMatchmakingMatchTypes,
} from '../../../../shared/matchmaking/MatchmakingEnums'

export function getMatchTypeEligibility(selectedMatchTypes: MatchmakingMatchTypes[]): boolean {
    const isRankedMatchTypeSelected = isRankedMatchType(selectedMatchTypes)
    if(!isRankedMatchTypeSelected) return true

    if(!ClientUserState.userState?.isLoggedIn) {
        new ViewPopupLogin()
        return false
    }

    const isCitiesAndKnightsMatchTypeSelected = isCitiesAndKnightsMatchType(selectedMatchTypes)
    const hasAccessToCitiesAndKnights = userHasAccessToRankedCitiesAndKnights(ClientUserState.userState?.items)
    if(isCitiesAndKnightsMatchTypeSelected && !hasAccessToCitiesAndKnights) {
        const checkAction = uiManagerEvents.premiumMembershipCheckAction()
        new ViewPopupBecomeMemberGameplay(checkAction, AnalyticEventValue.PopupMembershipIncentivesRankedCitiesAndKnights)
        return false
    }

    const isEligibleForRanked = UserSessionUtils.userEligibleForRanked()
    if(!isEligibleForRanked) {
        const requiredNumberOfGamesForRanked = RankedConstants.NumberOfGamesToUnlockRanked
        const rankedLockedError = new ErrorsMatchmaking.RankedLocked(ClientUserState.userState.totalCompletedGameCount, requiredNumberOfGamesForRanked)
        showMatchmakingErrorPopup(rankedLockedError)
        return false
    }

    return true
}

export function getDescriptionForSelectedMatchTypeAndEligibility(selectedMatchTypes: MatchmakingMatchTypes[]): {
    description: TranslationObject
    eligibleForMatchType: boolean
} {
    const isRankedMatchTypeSelected = isRankedMatchType(selectedMatchTypes)
    if(!isRankedMatchTypeSelected) {
        return {
            description: {key: 'strings:homePage.matchmakingPopup.playAgainstSimilarKarma'},
            eligibleForMatchType: true,
        }
    }

    if(!ClientUserState.userState?.isLoggedIn) {
        return {
            description: {key: 'strings:homePage.ranked.logInToPlayRanked'},
            eligibleForMatchType: false,
        }
    }

    const isCitiesAndKnightsMatchTypeSelected = isCitiesAndKnightsMatchType(selectedMatchTypes)
    const hasAccessToCitiesAndKnights = userHasAccessToRankedCitiesAndKnights(ClientUserState.userState?.items)
    if(isCitiesAndKnightsMatchTypeSelected && !hasAccessToCitiesAndKnights) {
        return {
            description: {key: 'strings:homePage.becomeAMemberToUnlock'},
            eligibleForMatchType: false,
        }
    }

    const isEligibleForRanked = UserSessionUtils.userEligibleForRanked()
    if(!isEligibleForRanked) {
        const requiredNumberOfGamesForRanked = RankedConstants.NumberOfGamesToUnlockRanked
        return {
            description: {
                key: 'strings:homePage.ranked.rankedIneligible',
                options: {count: requiredNumberOfGamesForRanked - ClientUserState.userState.totalCompletedGameCount},
            },
            eligibleForMatchType: false,
        }
    }

    return {
        description: {key: 'strings:homePage.matchmakingPopup.playAgainstSimilarRating'},
        eligibleForMatchType: true,
    }
}

export function showMatchmakingErrorPopup(error: BaseError) {
    const title: TranslationObject = error.title
    const errorMessage: TranslationObject = error.description
    const checkAction = () => undefined
    const xAction = () => undefined
    const canCancel = true
    new ViewPopup(title, errorMessage, checkAction, xAction, canCancel, {showXButton: false}).show()
}

function isCitiesAndKnightsMatchType(selectedMatchTypes: MatchmakingMatchTypes[]): boolean {
    for(const matchType of selectedMatchTypes) {
        if(citiesAndKnightsMatchmakingMatchTypes.has(matchType as MatchmakingMatchTypes)) return true
    }
    return false
}

function isRankedMatchType(selectedMatchTypes: MatchmakingMatchTypes[]): boolean {
    for(const matchType of selectedMatchTypes) {
        if(rankedMatchmakingMatchTypes.has(matchType as MatchmakingMatchTypes)) return true
    }
    return false
}
